import React, { useState, useEffect } from "react";
import { setTitle } from "../helpers/MetaTag";
import Button from "../components/form/Button";
import Select from "../components/form/Select";
import Input from "../components/form/Input";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { postData } from "../services/api";
import { authLogin } from "../store/authSlice";
import { Link } from "react-router-dom";
import toastr from "toastr";
import { useTranslation } from "react-i18next";
import { MAIN_LOGO } from "../constant/Constant";
import Image from "../components/elements/Image";

const Login = () => {
  setTitle(
    "Succession Planning Software for your Business with Succession Now | Login"
  );
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [countdown, setCountdown] = useState(0); // Initialize countdown to 60 seconds
  const [isDisabled, setIsDisabled] = useState(false);
  const [isResending, setIsResending] = useState(false);

  //const [isNext, setIsNext] = useState(false);
  const [isLogin, setIsLogin] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [roleCode, setRoleCode] = useState("");
  const [companyId, setCompanyId] = useState("");
  const [companies, setCompanies] = useState([]);
  const [otp,setOtp] = useState("");
  const [isStep, setIsStep] = useState(1);
  const [width, setWidth] = useState(window?.screen?.width);
  const [height, setHeight] = useState(window?.screen?.height);
  const handleWindowSizeChange = () => {
    setWidth(window?.screen?.width);
    setHeight(window?.screen?.height);
  };

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  // const onSubmit = async (e) => {
  //   e.preventDefault();
  //   //setIsNext(true);
  //   try {
  //     const companyData = await postData("check-companies", {
  //       email: email,
  //       password: password,
  //     });
  //     if (companyData.status && companyData.status === 200) {
  //       if (companyData.data && companyData.data.length > 0) {
  //         if (companyData.data && companyData.data.length > 1) {
  //           setCompanies(
  //             companyData.data.map((value, key) => {
  //               return {
  //                 _id: value?.company_details?._id,
  //                 name: value?.company_details?.name,
  //               };
  //             })
  //           );
  //           setRoleCode(companyData.data[0].role_details?.code);
  //         } else {
  //           setCompanyId(companyData.data[0].company_details?._id);
  //           setRoleCode(companyData.data[0].role_details?.code);
  //         }
  //         setIsStep(2);
  //         //setIsNext(false);
  //       } else {
  //         toastr.error("No record found!");
  //         //setIsNext(false);
  //       }
  //     } else {
  //       toastr.error(companyData.message);
  //       //setIsNext(false);
  //     }
  //   } catch (error) {
  //     toastr.error(error.message);
  //     //setIsNext(false);
  //   }
  // };

  const onSubmit = async (e) => {
    e.preventDefault();
    //setIsNext(true);
    setIsLogin(true);
    try {
      const companyData = await postData("verify-2fa-otp", {
        email: email,
        otp: otp,
      });
      if (companyData.status && companyData.status === 200) {
        if (companyData.data && Object.keys(companyData.data).length > 0) {
            setIsLogin(false);
            dispatch(authLogin(companyData.data));
            localStorage.setItem("accessToken", companyData?.accessToken);
            localStorage.setItem("role", companyData?.data?.code);
            return navigate("/dashboard");
        } else {
          setIsLogin(false);
          toastr.error("No record found!");
          //setIsNext(false);
        }
      } else {
        toastr.error(companyData.message);
        setIsLogin(false);
        //setIsNext(false);
      }
    } catch (error) {
      toastr.error(error.message);
      setIsLogin(false);
      //setIsNext(false);
    }
  };

  const onLogin = async (e) => {
    e.preventDefault();
    setIsLogin(true);
    if ((width <= 990 && width > height) || (width <= 640 && width < height)) {
      toastr.error(t("mobile_device_manage"));
      setIsLogin(false);
    } else {
      try {
        const settingsData = await postData("setting/details", {});
        const userData = await postData("login", {
          email: email,
          password: password,
          code: roleCode,
          company_id: companyId,
        });
        if (userData.status && userData.status === 200) {
          if(userData.data && (settingsData.data.email_otp_enabled && userData.data.email_otp_enabled)){
            setIsStep(2);
            setCountdown(60);
            setIsDisabled(true);
            setIsLogin(false);
          }else{
            setIsLogin(false);
            dispatch(authLogin(userData.data));
            localStorage.setItem("accessToken", userData?.accessToken);
            localStorage.setItem("role", userData?.data?.code);
            //toastr.success(userData.message);
            return navigate("/dashboard");
          }          
        } else {
          toastr.error(userData.message);
          setIsLogin(false);
        }
      } catch (error) {
        toastr.error(error.message);
        setIsLogin(false);
      }
    }
  };

  useEffect(() => {
    let interval;
    if (countdown > 0 && isDisabled) {
      interval = setInterval(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);
    } else {
      if (countdown === 0) {
        clearInterval(interval);
        setIsDisabled(false);
      }
    }

    return () => clearInterval(interval); // Clean up interval on component unmount
  }, [countdown, isDisabled]);

  const handleResendOtp = async () => {
    setIsResending(true);
    try {
      const otpData = await postData("resend-otp", {
        email: email,
        type : '2fa'
      });
      if (otpData.status && otpData.status === 200) {
        setIsResending(false);
        if (countdown === 0) {
          setCountdown(60);
          setIsDisabled(true);
        }        
      } else {
        toastr.error(otpData.message);
        setIsResending(false);
      }
    } catch (error) {
      toastr.error(error.message);
      setIsResending(false);
    }    
  };

  return (
    <>
      <div className="min-h-screen bg-gray-100 flex flex-col justify-center">
        <div className="relative py-3 max-w-[288px] sm:max-w-md mx-auto w-full ">
          <div className="absolute inset-0 bg-gradient-to-r from-teal-500 to-teal-600 shadow-lg transform -skew-y-6 sm:skew-y-0 -rotate-6 rounded-3xl"></div>
          <div className="relative px-4 py-10 bg-white shadow-lg rounded-3xl ">
            <Link to={"/"}>
              <div className="h-10 sm:h-14 w-full flex justify-center object-contain mb-5">
                <Image
                  src={MAIN_LOGO}
                  alt={""}
                  width={"100%"}
                  height={"100%"}
                  classes={"object-contain object-center"}
                />
              </div>
            </Link>

            {isStep && isStep === 1 ? (
              <div className="max-w-64 sm:max-w-xs mx-auto ">
                <div className="relative space-y-1 mb-5">
                  <h1 className="text-lg sm:text-2xl font-bold text-center text-slate-700">
                    {t("login")}
                  </h1>
                  <div className="text-sm sm:text-base text-slate-900 text-center font-medium">
                    {t("enter_your_email_address_to_login")}
                  </div>
                </div>
                <form className="space-y-2 sm:space-y-4 w-full">
                  <div className="relative z-0 w-full group">
                    <Input
                      inputType={"email"}
                      inputClasses={
                        "block h-10 !px-0 w-full text-sm text-gray-900 bg-transparent !border-0 !border-b-2 !rounded-none border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-teal-500 peer"
                      }
                      inputName={"floating_email"}
                      inputPlaceholder={t("work_email_address")}
                      inputValue={email}
                      setInput={setEmail}
                      functions={onLogin}
                    />
                  </div>
                  <div className="relative z-0 w-full group">
                    <Input
                      inputType={"password"}
                      inputClasses={
                        "block h-10 !pl-0 !pr-8 w-full text-sm text-gray-900 bg-transparent !border-0 !border-b-2 !rounded-none border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-teal-500 peer"
                      }
                      inputPlaceholder={t("your_password")}
                      inputName={"floating_password"}
                      inputValue={password}
                      setInput={setPassword}
                      functions={onLogin}
                    />
                  </div>
                  <div className="relative flex justify-center !mt-8">
                    <Button
                      buttonClasses=""
                      buttonLabelClasses=""
                      buttonType={"button"}
                      buttonIcon={
                        isLogin
                          ? "fa-light fa-spinner fa-spin"
                          : "fa-light fa-arrow-right-to-arc"
                      }
                      buttonIconPosition={"left"}
                      buttonLabel={t("login")}
                      functions={onLogin}
                      buttonHasLink={false}
                      buttonDisabled={isLogin}
                    />
                  </div>

                  <div className="relative flex items-center justify-center">
                    <div className="">
                      <Link
                        to={"/forgot-password"}
                        className="text-teal-500 font-medium text-sm"
                      >
                        {t("forgot_password")}
                      </Link>
                    </div>
                  </div>
                </form>
              </div>
            ) : (
              <div className="max-w-xs mx-auto ">
                <div className="relative space-y-1 mb-5">
                  <h1 className="text-2xl font-bold text-center text-slate-700">
                    {t("twofa_verification")} {/* Change this to the heading you want */}
                  </h1>
                  <div className="text-base text-slate-900 text-center font-medium">
                    {t("enter_the_otp_sent_to_your_email")} {/* Update subtitle with appropriate message */}
                  </div>
                </div>
                <form className="space-y-4 w-full">
                  {/* {companies && companies.length > 0 && (
                    <div className="relative z-[4] w-full group">
                      <Select
                        xPlacement={"left"}
                        dropdownButtonClass={
                          "border-l-0 border-r-0 border-t-0 border-b-2 border-gray-300 bg-transparent !pl-0 rounded-none "
                        }
                        dropdownClass={"!w-full z-10 !bg-white"}
                        // label={'Companies'}
                        selectedValue={companyId}
                        dropdownData={[
                          { _id: "", label: "Select", value: "" },
                          ...companies.map((item) => ({
                            _id: item?._id,
                            label: item?.name,
                            value: item?._id,
                          })),
                        ]}
                        getSelectedValue={(e) => setCompanyId(e._id)}
                      />
                    </div>
                  )} */}
                  <div className="relative z-[3] w-full group">
                    <Input
                      inputClasses={
                        "block h-10 !pl-0 !pr-8 w-full text-sm text-gray-900 bg-transparent !border-0 !border-b-2 !rounded-none border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-teal-500 peer"
                      }
                      inputType={"number"}
                      inputPlaceholder={t("enter_otp")}
                      inputValue={otp}
                      setInput={setOtp}
                    />
                  </div>
                  <div className="relative flex justify-center !mt-8">
                    <Button
                      buttonClasses=""
                      buttonLabelClasses=""
                      buttonType={"button"}
                      buttonIcon={
                        isLogin
                          ? "fa-light fa-spinner fa-spin"
                          : "fa-light fa-arrow-right-to-arc"
                      }
                      buttonIconPosition={"left"}
                      buttonLabel={t("login")}
                      functions={onSubmit}
                      buttonHasLink={false}
                      buttonDisabled={isLogin}
                    />
                  </div>
                  <div className="relative flex items-center justify-center">
                    <div>
                      <Button
                        buttonClasses={`!bg-transparent !text-teal-500 font-medium text-sm focus:outline-none ${
                          isDisabled || isResending ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'
                        }`}
                        buttonType={"button"}
                        buttonIcon={
                          (isDisabled && isResending)
                            ? "fa-light fa-spinner fa-spin"
                            : "fa-light fa-clock"
                        }
                        buttonIconPosition={"left"}
                        buttonLabel={isResending ? (
                            t("sending")
                        ) : isDisabled ? (
                          `${t("resend_otp")} (${countdown}s)`
                        ) : (
                          t("resend_otp")
                        )}
                        functions={handleResendOtp}
                        buttonHasLink={false}
                        buttonDisabled={isDisabled}
                      />
                    </div>
                  </div>
                </form>
                {/* <div className="flex gap-1 item-center justify-center text-slate-400 text-sm pt-4">
                  {t("dont_have_an_account")}
                  <Link to={"/signup"} className="text-teal-500 font-semibold">
                    {t("create_one_here")}
                  </Link>
                </div> */}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
